import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import {
  VERIFY_CAPTCHA,
  VERIFY_CAPTCHA_FAIL,
  VERIFY_CAPTCHA_SUCCESS,
  type VerifyCaptchaAction
} from '../redux/captchaReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* VerifyCaptchaFlow(action: VerifyCaptchaAction): Generator<any, void, any> {
  try {
    yield call(apiCall, {
      endpoint: '/api/v2/captcha/verify',
      method: POST,
      params: { token: action.payload }
    })
    yield put(VERIFY_CAPTCHA_SUCCESS())
    window.location.reload()
  } catch (error) {
    yield put(VERIFY_CAPTCHA_FAIL())
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* VerifyCaptchaSaga(): Generator<any, void, any> {
  yield takeLatest(VERIFY_CAPTCHA, VerifyCaptchaFlow)
}
